<template>
  <div class="alarmHistory">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div
          style="width:100vw"
        >
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">警報履歷</span>
              </b-col>

              <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                <b-row>
                  <commonQueryIoT />
                </b-row>
              </b-col>

              <b-col cols="12" style="margin-top: 2rem">
                <queryResult />
              </b-col>

              <singleChart class="text-left" style="margin-top: 2rem" />

              <b-col cols="12" class="text-right">
                <exportCsv />
              </b-col>

              <b-col
                cols="12"
                class="text-right mx-0 px-0"
                style="margin-top: 0.6rem"
              >
                <alarmHistoryData class="text-left" />
              </b-col>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import $ from "jquery";
import alertModal from "@/components/alertModal.vue";
import chart from "@/components/chart.vue";
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import alarmHistoryData from "@/components/alarmHistoryData.vue";
import queryResult from "@/components/queryResult.vue";
import singleChart from "@/components/singleChart.vue";
import exportCsv from "@/components/exportCsv.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "alarmHistory",
  data() {
    return {
      query_date: "",
      device_name: "",
      alarmHistoryChart: {
        name: {
          chartId: "alarmHistoryChart",
          chartName: "警報履歷圖表",
        },
        options: [
          // {
          //   text: "依機台",
          //   value: {
          //     name: "alarmHistoryAlarmChart-device",
          //     data: {
          //       senTime: [],
          //       senData: {
          //         bar: {},
          //         line: {
          //           name: "平均警報次數",
          //           data: [],
          //           color: "#FF3300",
          //         },
          //         unit: "次數",
          //       },
          //       senType: "VerticalBarLine",
          //     },
          //   },
          // },
          {
            text: "依警報類型",
            value: {
              name: "alarmHistoryAlarmChart-abn",
              data: {
                senTime: [],
                senData: {
                  bar: {},
                  line: {
                    name: "平均警報次數",
                    data: [],
                    color: "#FF3300",
                  },
                  unit: "次數",
                },
                senType: "VerticalBarLine",
              },
            },
          },
        ],
      },
    };
  },
  created: function () {
    this.setCommonQueryData();
    this.setQueryInput();
    // this.set_alarmHistoryDataFields(this.alarmHistoryDataFields);
    this.set_singleChartName(this.alarmHistoryChart.name);
    this.set_singleChartSelected(this.alarmHistoryChart.options[0].value);
    this.set_singleChartOptions(this.alarmHistoryChart.options);
  },
  mounted: function () {
    let vm = this;
    vm.resetExportCsv();
    vm.setExportDataTitle();
  },
  components: {
    alertModal,
    chart,
    commonQueryIoT,
    alarmHistoryData,
    queryResult,
    singleChart,
    exportCsv,
  },
  watch: {
    mainQueryResponse: {
      handler() {
        let vm = this;
        vm.reset([]);
        if (
          vm.mainQueryResponse == "查無資料" ||
          vm.mainQueryResponse == "當日無異常資料" ||
          vm.mainQueryResponse == "時間尚未選擇"
        ) {
          // vm.set_alertMsg(vm.mainQueryResponse);
          // vm.settimeout_alertModal();
          return;
        }
        var itemsarray = [];
        var devicearray = [];
        if (vm.mainQueryResponse[0].device_detail_data.length > 0) {
          for (
            var i = 0;
            i < vm.mainQueryResponse[0].device_detail_data.length;
            i++
          ) {
            var itemsobj = {};
            itemsobj["alarmCode"] =
              vm.mainQueryResponse[0].device_detail_data[i]["alarmCode"];
            itemsobj["alarmDetail"] =
              vm.mainQueryResponse[0].device_detail_data[i]["alarmDetail"];
            itemsobj["alarmVideo"] =
              vm.mainQueryResponse[0].device_detail_data[i]["alarmVideo"];
            itemsobj["startTime"] =
              vm.mainQueryResponse[0].device_detail_data[i]["startTime"];
            itemsobj["endTime"] =
              vm.mainQueryResponse[0].device_detail_data[i]["endTime"];
            itemsobj["continuousTime"] =
              vm.mainQueryResponse[0].device_detail_data[i]["continuousTime"];
            // itemsobj["device"] =
            //   vm.mainQueryResponse[0].device_detail_data[i]["device"];
            // itemsobj["placeItem"] =
            //   vm.mainQueryResponse[0].device_detail_data[i]["placeItem"];
            // itemsobj["groupItem"] =
            //   vm.mainQueryResponse[0].device_detail_data[i]["groupItem"];
            // itemsobj["classItem"] =
            //   vm.mainQueryResponse[0].device_detail_data[i]["classItem"];

            itemsarray.push(itemsobj);
          }

          console.log(itemsarray);
          // vm.alarmHistoryChart.options[0].value.data.senTime =
          //   vm.mainQueryResponse[0].device_data.data_time;
          // vm.alarmHistoryChart.options[0].value.data.senData.bar =
          //   vm.mainQueryResponse[0].device_data.data;

          vm.alarmHistoryChart.options[0].value.data.senTime =
            vm.mainQueryResponse[0].abn_species.data_time;
          vm.alarmHistoryChart.options[0].value.data.senData.bar =
            vm.mainQueryResponse[0].abn_species.data;
          vm.alarmHistoryChart.options[0].value.data.senData.line.data =
            vm.mainQueryResponse[0].abn_species.line_data;

          vm.query_date =
            vm.mainQueryResponse[0].query_date[0].split(" ")[0] +
            "~" +
            vm.mainQueryResponse[0].query_date[1].split(" ")[0];

          vm.set_queryResultItem([
            {
              date: vm.query_date,
              site: vm.mainQueryResponse[0].query_date[2],
              process: vm.mainQueryResponse[0].query_date[3],
              group: vm.mainQueryResponse[0].query_date[4],
              device: vm.mainQueryResponse[0].query_date[5],
            },
          ]);
          vm.set_singleChartName(vm.alarmHistoryChart.name);
          vm.set_singleChartSelected(vm.alarmHistoryChart.options[0].value);
          vm.set_singleChartOptions(vm.alarmHistoryChart.options);
          vm.set_alarmHistoryDataItem(itemsarray);
          vm.set_deviceName(vm.mainQueryResponse[0].query_date[5]);
          vm.set_exportData(itemsarray);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      alarmHistoryDataFields: "alarmHistoryData/get_alarmHistoryDataFields",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_alarmHistoryDataItem: "alarmHistoryData/set_alarmHistoryDataItem",
      clear_alarmHistoryDataItem: "alarmHistoryData/clear_alarmHistoryDataItem",
      set_deviceName: "alarmHistoryData/set_deviceName",
      set_queryResultItem: "queryResult/set_queryResultItem",
      clear_queryResultItem: "queryResult/clear_queryResultItem",
      set_singleChartSelected: "singleChart/set_singleChartSelected",
      set_singleChartOptions: "singleChart/set_singleChartOptions",
      set_singleChartName: "singleChart/set_singleChartName",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("MainQuery");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        startTime: true,
        endTime: true,
        startMinTime: false,
        endMinTime: false,
        process: true,
        deviceCode: true,
        productCode: false,
        workCode: false,
        group: false,
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: true,
        startMinTime: false,
        endMinTime: false,
        process: true,
        deviceCode: true,
        productCode: false,
        workCode: false,
        group: false,
      });
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      vm.alarmHistoryDataFields.forEach((data) => {
        exportDataTitle.push(data.label);
      });
      vm.set_exportDataTitle(exportDataTitle);
    },
    onClick() {},
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    this.clear_queryResultItem();
    this.clear_alarmHistoryDataItem();
    // this.clearTimer();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/alarmHistory.vue